import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept"]

import { computed, ref, reactive } from 'vue';
import { ElNotification } from 'element-plus';
import { useI18n } from 'vue-i18n';
import InputAction from '@/components/Form/InputAction.vue';
import { Upload, UploadedPayloadType } from '@/utils/fileUploader';
import IconCopy from '@/components/icons/Copy.vue';
import UploadIcon from '@/components/icons/Upload.vue';

interface Props {
  accept?: string;
  url?: string;
  error?: boolean;
  disabledCopy?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    accept: { default: '' },
    url: { default: '' },
    error: { type: Boolean, default: false },
    disabledCopy: { type: Boolean, default: false },
    disabled: { type: Boolean }
  },
  emits: ["fileLoading", "hasError", "fileUpdate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

_useCssVars(_ctx => ({
  "44e0b300": (progress.value)
}))

const { t } = useI18n();

const emits = __emit;

const props = __props;
const fileInputEl = ref<HTMLInputElement | null>(null);

const file = ref<File | null>(null);
const hasError = computed(() => props.error);
const fileName = computed(() => props?.url || file.value?.name);
const uploader = reactive(new Upload());
const isCopyDisabled = computed(() => uploader.fileUploading || props.disabledCopy);
const progress = computed(
  () => (!uploader.fileUploading && fileName.value ? '100%' : `${Math.ceil(uploader.progress / 1.1)}%`)
);
const inputLabel = computed(() => {
  if (uploader.fileUploading) {
    return t('alerts.fileLoading');
  }
  return hasError.value ? t('alerts.fileNotFound') : fileName.value;
});

const handleUploadClick = () => {
  fileInputEl.value?.click();
};

const getFileExtension = (
  mimeType: string
): string => mimeType.split('/').pop() || mimeType;

const handleFileChange = async (event: Event) => {
  const { files } = event.target as HTMLInputElement;

  if ((!files || !props.accept.includes(
    getFileExtension(files[0].type)
  )) && props.accept) {
    ElNotification({
      message: t('notifications.fileExtension', { extension: props.accept }),
      type: 'warning',
      position: 'bottom-right',
      dangerouslyUseHTMLString: true,
    });
    return;
  }
  const inputElement = fileInputEl.value;
  if (!inputElement?.files?.[0]) {
    emits('fileLoading', false);
    return false;
  }
  const [selectedFile] = inputElement.files;
  file.value = selectedFile;
  emits('fileLoading', true);
  const response: UploadedPayloadType = await uploader.downloadFile(file.value);
  if (!response?.name || !response?.url) {
    emits('hasError', true);
    return console.error(t('missingFileLink'));
  }

  emits('fileUpdate', response);
  emits('fileLoading', false);
};

const copyToClipboard = () => {
  if (!fileName.value) { return; }
  navigator.clipboard.writeText(fileName.value);
};

__expose({
  clickUploadInput: handleUploadClick,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'freeze': uploader.fileUploading, disabled: _ctx.disabled }, "file-upload"])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["file-upload__label", {
        'file-upload__selected': fileName.value || hasError.value,
        'file-upload__selected_has-error': hasError.value,
      }])
    }, [
      _createElementVNode("input", {
        ref_key: "fileInputEl",
        ref: fileInputEl,
        type: "file",
        accept: _ctx.accept,
        onChange: handleFileChange
      }, null, 40, _hoisted_1),
      _createElementVNode("span", {
        class: _normalizeClass(["file-upload__name", { 'file-upload__name_has-error': hasError.value }])
      }, _toDisplayString(inputLabel.value), 3)
    ], 2),
    (hasError.value || !fileName.value)
      ? (_openBlock(), _createBlock(InputAction, {
          key: 0,
          disabled: _ctx.disabled,
          onClick: handleUploadClick
        }, {
          default: _withCtx(() => [
            _createVNode(UploadIcon)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : (_openBlock(), _createBlock(InputAction, {
          key: 1,
          disabled: isCopyDisabled.value,
          onClick: copyToClipboard
        }, {
          default: _withCtx(() => [
            _createVNode(IconCopy)
          ]),
          _: 1
        }, 8, ["disabled"]))
  ], 2))
}
}

})